module.exports = __webpack_public_path__ + "static/media/logo-nose.0af1f792.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/logo-nose.svg
// module id = 405
// module chunks = 0